const Colors = {
  // Signature Colors
  QLIK_GREEN: '#009845',
  QLIK_GREY: '#54565A',
  // Flood Colors
  TANZANITE: '#009845',
  SLATE: '#244B5A',
  TURQUOISE: '#006580',
  TURQUOISE_LIGHT: '#0180a3',
  TURQUOISE_DARK: '#00485b',
  AQUAMARINE: '#10CFC9',
  WINE: '#4c0038',
  WINE_LIGHT: '#c12e9a',
  WINE_DARK: '#870064',
  AMETHYST: '#655DC6',
  STONE: '#C4CFDA',
  // Supporting Colors
  SAPPHIRE: '#005CB9',
  EMERALD: '#006937',
  EMERALD_LIGHT: '#008243',
  EMERALD_DARK: '#004f28',
  RUBY: '#E7004C',
  // Highlight Colors
  CORAL: '#FF8E9F',
  TOPAZ: '#FFC72A',
  PERIDOT: '#C2D500',
  // GREYs
  // https://www.w3schools.com/colors/colors_picker.asp
  GREY_0: '#000000',
  GREY_5: '#0d0d0d',
  GREY_10: '#1a1a1a',
  GREY_15: '#262626',
  GREY_20: '#333333',
  GREY_25: '#404040',
  GREY_30: '#4d4d4d',
  GREY_35: '#595959',
  GREY_40: '#666666',
  GREY_45: '#737373',
  GREY_50: '#808080',
  GREY_55: '#8c8c8c',
  GREY_60: '#999999',
  GREY_65: '#a6a6a6',
  GREY_70: '#b3b3b3',
  GREY_75: '#bfbfbf',
  GREY_80: '#cccccc',
  GREY_85: '#d9d9d9',
  GREY_90: '#e6e6e6',
  GREY_95: '#f2f2f2',
  GREY_100: '#ffffff',
};

export default Colors;
